import {
  faUser,
  faEnvelope,
  faPhone,
  faGlobe,
  faMap,
  faUsers,
  faCheckSquare,
  faMusic,
  faStar,
  faTag,
  faPray,
  faCalendar,
  faLocationDot,
  faFileAlt,
  faPhoneSquare,
} from "@fortawesome/free-solid-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
//import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
//import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Field map configuration
 * Specifies if a field should be displayed and if it is mandatory for each category
 */
const retreatDetails = {
  default: {
    fields: {
      firstName: { display: true, mandatory: true, type: "text", icon: faUser },
      lastName: { display: true, mandatory: true, type: "text", icon: faUser },
      email: {
        display: true,
        mandatory: true,
        type: "email",
        icon: faEnvelope,
      },
      phone: { display: true, mandatory: true, type: "tel", icon: faPhone },
      consentToUseData: {
        display: true,
        mandatory: true,
        type: "checkbox",
        icon: faCheckSquare,
      },
    },
  },
  "11NOV2025": {
    fields: {
      firstName: {
        display: true,
        mandatory: true,
        type: "text",
        icon: faUser,
        order: 1,
      },
      lastName: {
        display: true,
        mandatory: true,
        type: "text",
        icon: faUser,
        order: 2,
      },
      email: {
        display: true,
        mandatory: false,
        type: "email",
        icon: faEnvelope,
        order: 3,
      },
      phone: {
        display: true,
        mandatory: false,
        type: "tel",
        icon: faPhone,
        order: 4,
      },
      prayerIntentions: {
        display: true,
        mandatory: false,
        type: "textarea",
        icon: faPray,
        order: 5,
      },
      category: {
        display: false,
        mandatory: true,
        type: "text",
        icon: faTag,
        order: 4,
        readOnly: true,
      },
    },
    details: {
      name: "Grace Anointing Healing & Deliverance Service ",
      reg_start_date: "1-SEP-2025",
      reg_end_date: "12-NOV-2025",
      email: "retreat@graceanointing.org",
      emailJS:"TMP_11NOV2025",
      brochure: true,
      date: "11-NOV-2025",
      time: "6:00 PM - 9:00 PM",
      location:
        "St.Thomas More Catholic Church, 1040 Flexer Avenue Allentown PA 18103",
      description:
        "We warmly invite you to a <strong>One Day Bible Convention</strong> led by <em>Fr. Dominic</em> for the <em>Philadelphia Diocese</em>. This is a powerful opportunity to experience the <strong>Outpouring of the Holy Spirit</strong>, inspired by: <em>“And suddenly there came from the sky a noise like a strong driving wind, and it filled the entire house in which they were. Then there appeared to them tongues as of fire, which parted and came to rest on each one of them.”</em><strong>— Acts 2:2-3</strong>",
      WOG: "<q>Whoever believes in the Son has eternal life, but whoever disobeys the Son will not see life, but the wrath of God remains upon him.</q><strong>— John 3:36</strong>",
      notes:
        "Please provide your <strong>full name</strong>.You can also include your <strong>prayer intentions</strong>. We encourage you to include your email if you'd like a response (<em>not mandatory</em>).",
    },
  },
  MarianConsecration: {
    fields: {
      firstName: {
        display: true,
        mandatory: true,
        type: "text",
        icon: faUser,
        order: 1,
      },
      lastName: {
        display: true,
        mandatory: true,
        type: "text",
        icon: faUser,
        order: 2,
      },
      email: {
        display: true,
        mandatory: true,
        type: "email",
        icon: faEnvelope,
        order: 3,
      },
      spouseEmail: {
        display: true,
        mandatory: false,
        type: "email",
        icon: faEnvelope,
        order: 4,
      },
      phone: {
        display: true,
        mandatory: true,
        type: "tel",
        icon: faPhone,
        order: 5,
      },
      category: {
        display: false,
        mandatory: true,
        type: "text",
        icon: faTag,
        order: 5,
        readOnly: true,
      },
      consentToUseData: {
        display: true,
        mandatory: true,
        type: "checkbox",
        icon: faInfoCircle,
        order: 6,
      },
    },
    details: {
      name: "33 Days Marian Consecration Daily Meeting",
      consentText:
        "I consent to attend mandatory meetings and prayers with Grace Anointing Ministry.",
      type: "online",
      brochure: false,
      email: "sabbath@graceanointing.org",
      zoomMeetingID: "88568769301",
      group: "US",
      time: "4:00 PM - 4:45 PM CST",
      date: "Every Sunday",
      emailJS: "TMP_Retreat_Online",
      location: "Zoom Online Meeting",
      description:
        "<p class='text-center'><strong>Registration for 33 Days Marian Consecration Daily Meeting (via Zoom)</strong></p><p>This is a <strong>mandatory daily video call</strong> for core members of the Ministry. As members of <em>33 Days Marian Consecration | Grace Anointing Ministry</em>, we are called to be spiritually prepared and equipped to serve our Lord along with Dominic Achan. This daily meeting will help us <strong>grow in faith, prayer, and intercession</strong>.</p>",
      WOG: "<q>“My soul magnifies the Lord, and my spirit rejoices in God my Savior.”</q><strong> — Luke 1:46-47</strong>",
      notes:
        "<p>Please ensure you are attending via video. You can provide spouse email if the spouse is also registered. This will help us to mark the attendance from the households.</p>",
    },
  },
  MarianSpiritualWarfare: {
    fields: {
      firstName: {
        display: true,
        mandatory: true,
        type: "text",
        icon: faUser,
        order: 1,
      },
      lastName: {
        display: true,
        mandatory: true,
        type: "text",
        icon: faUser,
        order: 2,
      },
      email: {
        display: true,
        mandatory: true,
        type: "email",
        icon: faEnvelope,
        order: 3,
      },
      spouseEmail: {
        display: true,
        mandatory: false,
        type: "email",
        icon: faEnvelope,
        order: 4,
      },
      phone: {
        display: true,
        mandatory: true,
        type: "tel",
        icon: faPhone,
        order: 5,
      },
      category: {
        display: false,
        mandatory: true,
        type: "text",
        icon: faTag,
        order: 5,
        readOnly: true,
      },
      consentToUseData: {
        display: true,
        mandatory: true,
        type: "checkbox",
        icon: faInfoCircle,
        order: 6,
      },
    },
    details: {
      name: "Marian Spiritual Warfare Weekly Meeting",
      consentText:
        "I consent to attend mandatory meetings and prayers with Grace Anointing Ministry.",
      type: "online",
      brochure: false,
      email: "info@graceanointing.org",
      zoomMeetingID: "86345628992",
      group: "US",
      time: "4:00 PM - 4:45 PM CST",
      date: "Every Sunday",
      emailJS: "TMP_Retreat_Online",
      location: "Zoom Online Meeting",
      description:
        "<p class='text-center'><strong>Registration for Marian Spiritual Warfare Weekly Meeting (via Zoom)</strong></p><p>This is a <strong>mandatory weekly video call</strong> for core members of the Ministry. As members of <em>Marian Spiritual Warfare | Grace Anointing Ministry</em>, we are called to be spiritually prepared and equipped to serve our Lord along with Dominic Achan. This weekly meeting will help us <strong>grow in faith, prayer, and intercession</strong>.</p>",
      WOG: "<q>My mother and my brothers are those who hear the word of God and act on it.</q><strong> — Luke 8:21</strong>",
      notes:
        "<p>Please ensure you are attending via video. You can provide spouse email if the spouse is also registered. This will help us to mark the attendance from the households.</p>",
    },
  },
};
// Get field placeholder
// Define placeholders for fields
const placeholders = {
  firstName: "Enter your first name",
  lastName: "Enter your last name",
  email: "Enter your email address",
  spouseEmail: "Enter your spouse's email address",
  phone: "Enter your phone number",
  address: "Enter your street address",
  city: "Enter your city",
  state: "Enter your state",
  zip: "Enter your ZIP code",
  country: "Enter your country",
  category: "Select a category",
  sabbathGroup: "Select your Sabbath group",
  participantCount: "Enter number of participants",
  retreatDateString: "Enter retreat date",
  musicalExperience: "Describe your musical experience",
  diocese: "Enter your diocese",
  ordinationYear: "Enter ordination year",
  emergencyContact: "Enter emergency contact number",
  consentToUseData: "",
  parentConsent: "",
  prayerIntentions: "Enter your prayer intentions",
  type: "Select type",
  status: "Select status",
  remarks: "Enter remarks",
};
// Get field label (convert camelCase to readable format)
export const getFieldLabel = (fieldName) => {
  return fieldName
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};
export const getFieldPlaceholder = (fieldName, isMandatory) => {
  return (
    (placeholders[fieldName] ||
      `Enter ${getFieldLabel(fieldName).toLowerCase()}`) +
    (!isMandatory ? " (Optional)" : "")
  );
};

export const getMandatoryFieldsFromConfig = (category) => {
  const config = retreatDetails[category] || retreatDetails.default;
  const fields = config.fields || {};
  const hasOrder = Object.values(fields).some(
    (field) => field.order !== undefined
  );
  if (hasOrder) {
    return Object.entries(fields)
      .filter(([_, value]) => value.mandatory)
      .sort((a, b) => {
        const orderA =
          a[1].order !== undefined ? a[1].order : Number.MAX_SAFE_INTEGER;
        const orderB =
          b[1].order !== undefined ? b[1].order : Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
      })
      .map(([key]) => key);
  }
  //console.log("getMandatoryFieldsFromConfig config:", config);
  return Object.entries(fields)
    .filter(([_, value]) => value.mandatory)
    .map(([key]) => key);
};

export const getRetreatDetails = (category) => {
  //console.log("getRetreatDetails category:", category);
  return retreatDetails[category] || {};
};

/**
 * Field validation rules (optional - for future enhancement)
 */
export const fieldValidationRules = {
  firstName: {
    required: true,
    minLength: 1,
    maxLength: 50,
    pattern: /^[a-zA-Z\s]+$/,
    errorMessage: "First name must be 2-50 characters and contain only letters",
  },
  lastName: {
    required: true,
    minLength: 1,
    maxLength: 50,
    pattern: /^[a-zA-Z\s]+$/,
    errorMessage: "Last name must be 2-50 characters and contain only letters",
  },
  email: {
    required: true,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMessage: "Please enter a valid email address",
  },
  spouseEmail: {
    required: false,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMessage: "Please enter a valid email address",
  },
  phone: {
    required: true,
    minLength: 10,
    pattern: /^[0-9\-\+\s\(\)]+$/,
    errorMessage: "Please enter a valid phone number",
  },
  participantCount: {
    required: true,
    min: 1,
    max: 20,
    errorMessage: "Participant count must be between 1 and 20",
  },
  consentToUseData: {
    required: true,
    mustBeTrue: true,
    errorMessage: "Consent is required to proceed",
  },
  address: {
    required: true,
    minLength: 5,
    maxLength: 100,
    errorMessage: "Please enter a valid address",
  },
  city: {
    required: true,
    minLength: 2,
    maxLength: 50,
    errorMessage: "Please enter a valid city",
  },
  state: {
    required: true,
    minLength: 2,
    maxLength: 50,
    errorMessage: "Please enter a valid state",
  },
  zip: {
    required: true,
    minLength: 4,
    maxLength: 10,
    pattern: /^[a-zA-Z0-9\-]+$/,
    errorMessage: "Please enter a valid ZIP code",
  },
  country: {
    required: true,
    minLength: 2,
    maxLength: 50,
    errorMessage: "Please enter a valid country",
  },
  sabbathGroup: {
    required: true,
    errorMessage: "Please select a Sabbath group",
  },
  emergencyContact: {
    required: true,
    minLength: 10,
    errorMessage: "Please enter a valid emergency contact number",
  },
  parentConsent: {
    required: true,
    mustBeTrue: true,
    errorMessage: "Parental consent is required",
  },
  instrument: {
    required: true,
    minLength: 2,
    maxLength: 50,
    errorMessage: "Please specify your instrument",
  },
  musicalExperience: {
    required: true,
    minLength: 2,
    maxLength: 100,
    errorMessage: "Please describe your musical experience",
  },
  diocese: {
    required: true,
    minLength: 2,
    maxLength: 100,
    errorMessage: "Please enter your diocese",
  },
  ordinationYear: {
    required: true,
    pattern: /^\d{4}$/,
    errorMessage: "Please enter a valid ordination year",
  },
  type: {
    required: true,
    errorMessage: "Please specify the type",
  },
  status: {
    required: true,
    errorMessage: "Please specify the status",
  },
  remarks: {
    required: false,
    maxLength: 200,
    errorMessage: "Remarks must be less than 200 characters",
  },
};

/**
 * Helper function to get mandatory fields for a category
 * @param {string} category - The retreat/event category
 * @returns {Array} - Array of mandatory field names
 */
export const getMandatoryFields = (category) => {
  //console.log("Getting mandatory fields for category:", category);
  //console.log(
  //  "Mandatory fields config:",
  //  getMandatoryFieldsFromConfig(category)
  //);
  const fields =
    retreatDetails[category]?.fields || retreatDetails.default.fields;
  const mandatoryFields = Object.entries(fields)
    .filter(([_, value]) => value.mandatory)
    .map(([key]) => key);
  //console.log("Mandatory fields for category", category, ":", mandatoryFields);
  return mandatoryFields;
};

/**
 * Helper function to check if a field is mandatory for a category
 * @param {string} field - The field name
 * @param {string} category - The retreat/event category
 * @returns {boolean} - True if field is mandatory
 */
export const isFieldMandatory = (field, category) => {
  const mandatoryFields = getMandatoryFields(category);
  return mandatoryFields.includes(field);
};

/**
 * Helper function to get all categories
 * @returns {Array} - Array of all available categories
 */
export const getAllCategories = () => {
  return Object.keys(retreatDetails).filter((key) => key !== "default");
};

export default retreatDetails;
